export const heroTags = ['Desktop-first', 'Readable telemetry', 'Portable release'];

export const heroFacts = [
  { label: 'Modes', value: 'Merge + Compress' },
  { label: 'Containers', value: 'MP4 / MOV / MKV / WebM' },
  { label: 'Acceleration', value: 'CPU / NVIDIA NVENC' },
];

export const highlightRows = [
  {
    index: '01',
    title: 'Plan before the encoder starts',
    description:
      'The workspace keeps format, compression profile, backend, and destination visible before the job leaves staging.',
  },
  {
    index: '02',
    title: 'Keep merge and compression in one language',
    description:
      'Switch between a single merged master and one-output-per-source compression without relearning the interface.',
  },
  {
    index: '03',
    title: 'Review the run, not just the result',
    description:
      'Progress, logs, history, and artifact references stay available after execution so the UI remains operationally useful.',
  },
];

export const githubUrl = 'https://github.com/d4v3-rm/dsk-electron-video-merger';
